import { TweetType } from '@edusense/tweet-client';
// Tweet Type 상수 정의 (TweetType enum 매핑)
const TweetResponseBasicInfoAllOfTwoTweetType = TweetType;
const TweetResponseReferencedTweetType = TweetType;
import { transformUserSummaryToAuthorInfo } from '@edusense/entities-user';
/**
 * 트윗 응답을 Tweet 인터페이스로 변환하는 함수
 * @param response API로부터 받은 트윗 응답
 * @returns 변환된 트윗 객체 또는 null
 */ export const convertTweetResponse = (response)=>{
    // 리트윗 처리
    if (response.basicInfo?.tweetType === TweetResponseBasicInfoAllOfTwoTweetType.RETWEET && response.referencedTweet?.type === TweetResponseReferencedTweetType.RETWEETED && response.referencedTweet?.tweet) {
        const originalTweetResponse = response.referencedTweet.tweet;
        const retweetAuthor = transformUserSummaryToAuthorInfo(response.author);
        const originalTweet = convertTweetResponse(originalTweetResponse);
        if (!originalTweet) return null;
        // 리트윗 정보 추가 (고유 ID 사용 및 상호작용 정보 수정)
        return {
            // 원본 트윗의 기본 정보 (내용, 작성자, 미디어 등)는 유지
            ...originalTweet,
            // 리트윗 자체의 ID와 생성 시간 사용
            id: Number(response.basicInfo?.id || 0),
            createdAt: response.basicInfo?.createdAt || originalTweet.createdAt,
            originalTweetId: originalTweet.id,
            isRetweet: true,
            retweetedBy: retweetAuthor,
            // 상호작용 상태는 리트윗 응답(response)의 userInteraction 사용
            isLiked: response.userInteraction?.liked || false,
            isRetweeted: response.userInteraction?.retweeted || false,
            isBookmarked: response.userInteraction?.bookmarked || false,
            isQuoted: response.userInteraction?.quoted || false,
            // 참여 수치는 원본 트윗의 것을 그대로 사용
            engagement: originalTweet.engagement
        };
    }
    // 일반 트윗, 답글, 인용 트윗 처리
    const pollData = convertPollResponse(response.poll);
    const { quotedContent, replyToUser } = processReferencedTweet(response.referencedTweet);
    const convertedTweet = {
        id: Number(response.basicInfo?.id || 0),
        content: response.basicInfo?.content || '',
        createdAt: response.basicInfo?.createdAt || '',
        author: transformUserSummaryToAuthorInfo(response.author),
        mediaUrls: response.media?.mediaUrls,
        engagement: {
            commentCount: Number(response.engagement?.commentCount || 0),
            retweetCount: Number(response.engagement?.retweetCount || 0),
            likeCount: Number(response.engagement?.likeCount || 0),
            viewCount: Number(response.engagement?.viewCount || 0)
        },
        isLiked: response.userInteraction?.liked || false,
        isRetweeted: response.userInteraction?.retweeted || false,
        isBookmarked: response.userInteraction?.bookmarked || false,
        isQuoted: response.userInteraction?.quoted || false,
        poll: pollData,
        quotedContent,
        replyToUser,
        isRetweet: false,
        retweetedBy: undefined,
        originalTweetId: Number(response.basicInfo?.id || 0)
    };
    return convertedTweet;
};
/**
 * 투표 응답을 PollData로 변환
 */ const convertPollResponse = (poll)=>{
    if (!poll) return undefined;
    console.log('Raw Poll Response from API:', JSON.stringify(poll, null, 2));
    const pollData = {
        pollId: poll.pollId || '',
        options: Array.isArray(poll.options) ? poll.options.map((opt)=>({
                optionId: opt.optionId || '',
                text: opt.text || '',
                votes: Number(opt.votes || 0),
                percentage: undefined
            })) : [],
        totalVotes: Number(poll.totalVotes || 0),
        durationMinutes: Number(poll.durationMinutes || 0),
        endsAt: poll.expiresAt || '',
        chosenOptionId: poll.userVotedOptionId || undefined
    };
    console.log('Converted PollData:', JSON.stringify(pollData, null, 2));
    return pollData;
};
/**
 * 참조된 트윗 처리 (인용, 답글)
 */ const processReferencedTweet = (referencedTweet)=>{
    if (!referencedTweet?.tweet) {
        return {};
    }
    const refTweet = referencedTweet.tweet;
    const refAuthor = transformUserSummaryToAuthorInfo(refTweet.author);
    if (referencedTweet.type === TweetResponseReferencedTweetType.QUOTED) {
        return {
            quotedContent: {
                id: String(refTweet.basicInfo?.id || '0'),
                content: refTweet.basicInfo?.content || '',
                createdAt: refTweet.basicInfo?.createdAt || '',
                author: refAuthor,
                mediaUrls: refTweet.media?.mediaUrls
            }
        };
    } else if (referencedTweet.type === TweetResponseReferencedTweetType.REPLIED_TO) {
        return {
            replyToUser: refAuthor
        };
    }
    return {};
};
/**
 * GraphQL FeedItem을 Tweet 타입으로 변환
 * @param feedItem GraphQL FeedItem (any 타입으로 forYouFeed와 userTweets 모두 지원)
 * @returns 변환된 Tweet 객체
 */ export const convertGraphQLFeedItemToTweet = (feedItem)=>{
    // 필수 필드 검증
    if (!feedItem || !feedItem.id || !feedItem.author) {
        console.error('[convertGraphQLFeedItemToTweet] Invalid feedItem:', feedItem);
        return null;
    }
    const author = {
        id: feedItem.author.id,
        username: feedItem.author.username,
        displayName: feedItem.author.displayName || feedItem.author.username,
        name: feedItem.author.displayName || feedItem.author.username,
        profileImageUrl: feedItem.author.avatarUrl || undefined,
        isVerified: feedItem.author.isVerified || false
    };
    // ✅ MongoDB ObjectId를 문자열 그대로 사용 (역변환 가능)
    const feedItemId = String(feedItem.id);
    const engagement = feedItem.engagement || {};
    return {
        id: feedItemId,
        content: feedItem.content || '',
        createdAt: feedItem.createdAt || new Date().toISOString(),
        author,
        mediaUrls: feedItem.mediaUrls || [],
        engagement: {
            commentCount: engagement.comments || 0,
            retweetCount: engagement.retweets || 0,
            likeCount: engagement.likes || 0,
            viewCount: engagement.views || 0
        },
        isLiked: feedItem.viewerHasLiked || false,
        isRetweeted: feedItem.viewerHasShared || false,
        isBookmarked: false,
        isQuoted: false,
        poll: undefined,
        quotedContent: undefined,
        replyToUser: undefined,
        isRetweet: false,
        retweetedBy: undefined,
        originalTweetId: feedItemId
    };
};
/**
 * Mock 트윗 생성 함수
 */ export const generateMockTweets = (pageSize, targetPage)=>{
    return Array.from({
        length: pageSize
    }, (_, index)=>({
            id: targetPage * pageSize + index,
            content: `이것은 ${targetPage}페이지의 ${index + 1}번째 트윗입니다.`,
            author: {
                id: `user-${index % 5}`,
                username: `user${index % 5}`,
                displayName: `사용자 ${index % 5}`,
                name: `사용자 ${index % 5}`,
                profileImageUrl: undefined
            },
            createdAt: new Date(Date.now() - Math.random() * 7 * 24 * 60 * 60 * 1000).toISOString(),
            engagement: {
                commentCount: Math.floor(Math.random() * 20),
                retweetCount: Math.floor(Math.random() * 50),
                likeCount: Math.floor(Math.random() * 100),
                viewCount: Math.floor(Math.random() * 1000)
            },
            isLiked: Math.random() > 0.5,
            isRetweeted: Math.random() > 0.8,
            isBookmarked: Math.random() > 0.9,
            isQuoted: Math.random() > 0.9,
            mediaUrls: [],
            poll: undefined,
            quotedContent: undefined,
            replyToUser: undefined,
            isRetweet: false,
            retweetedBy: undefined,
            originalTweetId: targetPage * pageSize + index
        }));
};
